// extracted by mini-css-extract-plugin
export default {"airCoverLogo":"styles_airCoverLogo__XBQ+B","learnMore":"styles_learnMore__j9KHx"};